define([
	"dojo/_base/declare",
	"Apparel/StructureItemTable",
	"Apparel/StructureItemThemeMixin"
], function(declare,StructureItemTable,StructureItemThemeMixin) {

    return declare([StructureItemTable,StructureItemThemeMixin],{

        /**
         *  summary: remove "ApplyColorRulesToThemes" action from toolbar if view node is not a Season type
         *  and resolve view path and/or filters
         */
        _resolveView: function() {
            if (this.getViewNodeType() != "Season") {
                var tb = this.defView.defToolbar;
                if (tb) {
                    tb.removeAction("ApplyColorRulesToThemes");
                }
            }
            this.inherited(arguments);
        }

	});
});